import React from 'react';
import { formatDateDisplay } from 'utils';
import * as DateFns from 'date-fns';
import classNames from 'classnames';

export interface iStayBadgeProps {
  startDate: string; // format: yyyy-mm-dd
  endDate?: string; // format: yyyy-mm-dd
  className?: string;
  hideNights?: boolean;
  hideDates?: boolean;
}

/**
 * Renders a badge showing the formatted dates, and the nights between them.
 * The nights is calculated as the absolute value of the difference in days between the dates
 *
 * @param props
 * @returns
 */
export const StayBadge = (props: iStayBadgeProps) => {
  const { hideNights = false, hideDates = false } = props;
  //   get how many days is between the dates

  const diff = props.endDate
    ? Math.abs(DateFns.differenceInDays(new Date(props.startDate), new Date(props.endDate)))
    : 0;

  return (
    <div className={classNames('flex items-center gap-10px', props.className)}>
      {!hideDates && (
        <>
          <span className="font-hurmegeometric-sans text-13px font-bold uppercase text-flint">
            {formatDateDisplay(props.startDate)}
            {props.endDate ? `-` + formatDateDisplay(props.endDate) : ''}
          </span>
        </>
      )}
      {!hideNights && (
        <>
          <span className="md:hidden font-hurmegeometric-sans text-13px text-flint bg-teal-20 uppercase p-3px">
            {diff} N
          </span>
          <span className="hidden md:inline-block font-hurmegeometric-sans text-13px text-flint bg-teal-20 uppercase p-3px">
            {diff} Nights
          </span>
        </>
      )}
    </div>
  );
};
